import { Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LoginForm } from './LoginForm';

function SignInContent() {
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect');
  const priceId = searchParams.get('priceId');
  const inviteId = searchParams.get('inviteId');

  return (
    <LoginForm 
      mode="signin"
      redirect={redirect}
      priceId={priceId}
      inviteId={inviteId}
    />
  );
}

export default function SignInPage() {
  return (
    <Suspense fallback={<div className="h-screen flex items-center justify-center">Loading...</div>}>
      <SignInContent />
    </Suspense>
  );
}
